/**
 * Release toggles. Each one hides a feature that is built but not yet ready to
 * ship - flip it to true to bring the feature back. The code behind a flag is
 * left untouched so re-enabling is a one-line change.
 */
export const FEATURE_FLAGS = {
  /** Light/Dark toggle in the sidebar footer. Off locks the app to light mode. */
  darkModeToggle: false,
  /** Settings button + panel in the sidebar footer. Off locks the theme to Saga Gold. */
  displaySettings: false,
  /** The /maintenance-control/* route and its sidebar entry. */
  maintenanceControl: false,
};
